module.exports = __webpack_public_path__ + "static/media/icon_tab_open_all.3956d6a6.svg";